import React from 'react';
import TextBase from './TextBase';
import { TText } from './types';

const Regular = ({ as = 'span', color = '', strong = false, ...rest }: TText) => (
  <TextBase {...rest} as={as} kind={`body-regular${strong ? '-strong' : ''}`} color={color} />
);

export default Regular;
